import { Directive, ElementRef, Inject, Input, OnInit, Renderer2, forwardRef } from '@angular/core';
import { Subject } from 'rxjs';
import { KeyboardListDirective } from './keyboard-list.directive';

/**
 * Eine Direktive, die als ein Kennsatz für KeyboardListDirective verwendet werden.
 */
@Directive({
    selector: '[commonKeyboardItem]'
})
export class KeyboardItemDirective<T> implements OnInit {

    /**
     * Definiert, ob den Item bei der Tastatur gesucht wird.
     */
    @Input() commonKeyboardItemSearchable = true;

    /**
     * Eine ID, die in der KeyboardListDirective benutzt wird.
     */
    @Input() commonKeyboardItemId: number;

    private ngUnsubscribe$: Subject<void> = new Subject<void>();

    constructor(private elementRef: ElementRef,
                private renderer: Renderer2,
                @Inject(forwardRef(() => KeyboardListDirective)) private parent: KeyboardListDirective<T>) {
    }

    ngOnInit() {
        // Es ermöglicht Fokussierung des Element. Da Standartmässig Li-Element nicht fokussierbar ist.
        this.renderer.setAttribute(this.elementRef.nativeElement, 'tabindex', '1');
    }

    focus() {
        this.elementRef.nativeElement.focus();
    }

    ngOnDestroy() {
        this.ngUnsubscribe$.next();
        this.ngUnsubscribe$.complete();
    }

    /**
     * Anhand Dom Text des Elements sucht die Position gegebenes "searchWord"
     *
     * @param searchWord Suchwert
     */
    search(searchWord: string) {
        if (!this.commonKeyboardItemSearchable) {
            return false;
        }
        return this.getSearchableText().search(searchWord);
    }

    /**
     * Liefert Dom Text von Element
     */
    private getSearchableText(): string {
        const text = this.elementRef.nativeElement.innerText;
        if (text === undefined) {
            return '';
        }
        return text.trim().toLowerCase();
    }
}
